import React from "react";
import CommunityNavBar from "./CommunityNavBar"; // Import sidebar component
import "./CommunityLayout.css"; // Layout-specific CSS

const CommunityLayout = ({ children }) => {
  return (
    <div className="CommunityLayout">
      <CommunityNavBar /> {/* Sidebar stays fixed */}
      <div className="CommunityContent">{children}</div> {/* Renders CommunityPage */}
    </div>
  );
};

export default CommunityLayout;
